import React, { useState, useEffect } from "react";
import Loader from "../Common/Loader";
import HeadToHeadService from "../../services/HeadToHeadService";
import moment from "moment";
import { Link } from "react-router-dom";
import H2HBattleList from "./H2HBattleList";
import H2HPlayOff from "./H2HPlayOff";
import GroupALeaderboard from "./GroupALeaderboard";
import GroupBLeaderboard from "./GroupBLeaderboard";
import H2hA from "./H2hA";
import H2hB from "./H2hB";
import H2HGroupPlayOff from "./H2hGroupPlayOff";
import MyH2H from "./MyH2H";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const ShowH2H = () => {
  useAutoAddQueryString();
  const [isLoading, setIsLoading] = useState(false);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [playOffLoading, setPlayOffLoading] = useState(false);
  const [allLeaderboardData, setAllLeaderboardData] = useState([]);
  const [getScheduleData, setGetScheduleData] = useState([]);
  const [myGetScheduleData, setMyGetScheduleData] = useState([]);
  const [playOffListing, setPlayOffListing] = useState([]);
  const [groupOneLeaderboard, setGroupOneLeaderboard] = useState([]);
  const [groupTwoLeaderboard, setGroupTwoLeaderboard] = useState([]);
  const [h2hType, setH2hType] = useState({});
  const fetchData = () => {
    setIsLoading(true);
    HeadToHeadService.getAllTypeLeaderboard().then((result) => {
      setAllLeaderboardData(result.data);
      setH2hType(result.h2HType);
      if (result?.h2HType?.type === "group") {
        HeadToHeadService.headToHeadGroupLeaderboard().then((groupResult) => {
          setGroupOneLeaderboard(groupResult.groupOneleaderBoard);
          setGroupTwoLeaderboard(groupResult.groupTwoleaderBoard);
        });
      }
      setIsLoading(false);
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleSchedule = () => {
    if (getScheduleData.length <= 0) {
      setScheduleLoading(true);
      HeadToHeadService.getScheduleData().then((result) => {
        setGetScheduleData(result.data);
        setScheduleLoading(false);
      });
    }
  };
  const handleMySchedule = () => {
    if (myGetScheduleData.length <= 0) {
      setScheduleLoading(true);
      HeadToHeadService.getMyScheduleData().then((result) => {
        setMyGetScheduleData(result.data);
        setScheduleLoading(false);
      });
    }
  };

  const handlePlayOff = () => {
    setPlayOffLoading(true);
    HeadToHeadService.getPlayOffListing().then((result) => {
      setPlayOffListing(result.data);
      setPlayOffLoading(false);
    });
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [h2hBattleData, setH2hBattleData] = useState([]);
  const [roundDetails, setRoundDetails] = useState([]);
  const handleH2HShow = (id) => {
    HeadToHeadService.showHeadToHeadRound(id).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setH2hBattleData(res.data);
        setRoundDetails(res.roundDetails);
      }
    });
    setIsModalOpen(!isModalOpen);
  };

  const handleMyH2H = () => {
    console.log("object");
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Head-2-Head</h2>
            </div>
            <div className="tab-content">
              <p>&nbsp;</p>
              <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
                {h2hType?.type === "all" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="Gameweek-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Gameweek"
                      type="button"
                      role="tab"
                      aria-controls="Gameweek"
                      aria-selected="true"
                    >
                      Rank
                    </button>
                  </li>
                )}
                {h2hType?.type === "group" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="leaderboardA-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#LeaderboardA"
                      type="button"
                      role="tab"
                      aria-controls="LeaderboardA"
                      aria-selected="true"
                    >
                      Rank A
                    </button>
                  </li>
                )}
                {h2hType?.type === "group" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="leaderboardB-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Leaderboardb"
                      type="button"
                      role="tab"
                      aria-controls="Leaderboardb"
                      aria-selected="true"
                    >
                      Rank B
                    </button>
                  </li>
                )}
                {h2hType?.type === "all" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="Matches-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#Matches"
                      type="button"
                      role="tab"
                      aria-controls="Matches"
                      aria-selected="true"
                      onClick={handleSchedule}
                    >
                      H2H
                    </button>
                  </li>
                )}
                {h2hType?.type === "group" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="h2ha-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#h2ha"
                      type="button"
                      role="tab"
                      aria-controls="h2ha"
                      aria-selected="true"
                      onClick={handleSchedule}
                    >
                      H2H A
                    </button>
                  </li>
                )}
                {h2hType?.type === "group" && (
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="h2hb-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#h2hb"
                      type="button"
                      role="tab"
                      aria-controls="h2hb"
                      aria-selected="true"
                      onClick={handleSchedule}
                    >
                      H2H B
                    </button>
                  </li>
                )}
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="Performances-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#Performances"
                    type="button"
                    role="tab"
                    aria-controls="Performances"
                    aria-selected="true"
                    onClick={handlePlayOff}
                  >
                    Playoff
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    id="myH2h-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#myH2h"
                    type="button"
                    role="tab"
                    aria-controls="myH2h"
                    aria-selected="true"
                    onClick={handleMySchedule}
                  >
                    My H2H
                  </button>
                </li>
              </ul>

              <div className="tab-content" id="myTabContent">
                {h2hType?.type === "all" && (
                  <div
                    className="tab-pane fade show active"
                    id="Gameweek"
                    role="tabpanel"
                    aria-labelledby="Gameweek-tab"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <div className="table-wrap">
                        <table className="main-table1 table innertable">
                          <thead>
                            <tr>
                              <th>Manager</th>
                              <th title="Played">P</th>
                              <th title="Wins">W</th>
                              <th title="Losses">L</th>
                              <th title="Ties">T</th>
                              <th title="Win %">W%</th>
                              <th title="Points For">PF</th>
                              <th title="Points Against">PA</th>
                              <th title="Points Difference">PD</th>
                              <th title="Points">PTS</th>
                            </tr>
                          </thead>
                          <tbody>
                            {allLeaderboardData &&
                              allLeaderboardData.map((item, key) => (
                                <tr key={key}>
                                  <td>{item?.full_name}</td>
                                  <td>{item?.played}</td>
                                  <td>{item?.wins}</td>
                                  <td>{item?.losses}</td>
                                  <td>{item?.ties}</td>
                                  <td>{item?.win_percentage}</td>
                                  <td>{item?.points_for}</td>
                                  <td>{item?.points_against}</td>
                                  <td>{item?.point_difference}</td>
                                  <td>{item?.points}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
                {h2hType?.type === "group" && (
                  <div
                    className="tab-pane fade show active"
                    id="LeaderboardA"
                    role="tabpanel"
                    aria-labelledby="leaderboardA-tab"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <div className="table-wrap">
                        <GroupALeaderboard
                          groupOneLeaderboard={groupOneLeaderboard}
                          leaderboardNumber={1}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {h2hType?.type === "group" && (
                  <div
                    className="tab-pane fade"
                    id="Leaderboardb"
                    role="tabpanel"
                    aria-labelledby="leaderboardB-tab"
                  >
                    <div id="table-scroll1" className="table-scroll">
                      <div className="table-wrap">
                        <GroupBLeaderboard
                          groupTwoLeaderboard={groupTwoLeaderboard}
                          leaderboardNumber={2}
                        />
                      </div>
                    </div>
                  </div>
                )}
                <div
                  className="tab-pane fade"
                  id="Matches"
                  role="tabpanel"
                  aria-labelledby="Matches-tab"
                >
                  <div id="table-scroll2" className="table-scroll">
                    <div className="table-wrap">
                      {scheduleLoading && <Loader />}
                      {!scheduleLoading && (
                        <table className="main-table2 table innertable">
                          <thead>
                            <tr>
                              <th scope="col">H2H</th>
                              <th scope="col">Duration</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {getScheduleData &&
                              getScheduleData.map((item, key) => (
                                <tr key={key}>
                                  <td>Round {item?.round}</td>
                                  <td>
                                    {moment(item.start_date).format("MMM D")}-
                                    {moment(item.end_date).format("MMM D")}
                                  </td>

                                  <td>
                                    {item?.is_generated && (
                                      <Link
                                        size="sm"
                                        onClick={() => handleH2HShow(item?.id)}
                                        className="more_link"
                                        style={{
                                          color: "white",
                                          // fontSize: "12px;",
                                        }}
                                      >
                                        View H2H
                                      </Link>
                                    )}
                                    {!item?.status && !item?.is_generated && (
                                      <Link
                                        size="sm"
                                        onClick={(e) => e.preventDefault()}
                                        className="more_link"
                                        style={{
                                          color: "white",
                                          // fontSize: "12px;",
                                        }}
                                      >
                                        N/A
                                      </Link>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                </div>

                {h2hType?.type === "group" && (
                  <div
                    className="tab-pane fade"
                    id="h2ha"
                    role="tabpanel"
                    aria-labelledby="h2ha-tab"
                  >
                    <div id="table-scroll2" className="table-scroll">
                      <H2hA
                        scheduleLoading={scheduleLoading}
                        getScheduleData={getScheduleData}
                      />
                    </div>
                  </div>
                )}
                {h2hType?.type === "group" && (
                  <div
                    className="tab-pane fade"
                    id="h2hb"
                    role="tabpanel"
                    aria-labelledby="h2hb-tab"
                  >
                    <div id="table-scroll2" className="table-scroll">
                      <H2hB
                        scheduleLoading={scheduleLoading}
                        getScheduleData={getScheduleData}
                      />
                    </div>
                  </div>
                )}

                <div
                  className="tab-pane fade"
                  id="Performances"
                  role="tabpanel"
                  aria-labelledby="Performances-tab"
                >
                  <div id="table-scroll4" className="table-scroll">
                    <div className="table-wrap">
                      {h2hType?.type === "all" && (
                        <H2HPlayOff playOffListing={playOffListing} />
                      )}
                      {h2hType?.type === "group" && (
                        <H2HGroupPlayOff playOffListing={playOffListing} />
                      )}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="myH2h"
                  role="tabpanel"
                  aria-labelledby="myH2h-tab"
                >
                  <div id="table-scroll4" className="table-scroll">
                    <MyH2H getScheduleData={myGetScheduleData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <H2HBattleList
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        h2hBattleData={h2hBattleData}
        roundDetails={roundDetails}
      />
    </>
  );
};

export default ShowH2H;
